module.exports = __webpack_public_path__ + "media/images/icon__community-987bb88ad02bac80f2141d6c2d5a5cf7.png";